import React from "react";
import Avatar from "@material-ui/core/Avatar";
import ButtonBase from "@material-ui/core/ButtonBase";
import { makeStyles } from "@material-ui/core/styles";
import { blueGrey, grey, green, red } from "@material-ui/core/colors";
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";
import PropTypes from "prop-types";
import Box from "@material-ui/core/Box";
import Chip from "@material-ui/core/Chip";
import photoPlaceholder from "../../../../assets/ic_empty_avatar.svg";
import { useChat } from "../../../../Providers/Data/ChatProvider.jsx";
import useDateUtils from "../../../../hooks/useDateUtils.js";

const useStyles = makeStyles((theme) => ({
  rootButton: {
    width: "100%",
  },
  buttonActive: {
    backgroundColor: blueGrey[50],
  },
  userName: {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    flex: 1,
    marginRight: 10,
    textAlign: "start",
  },
  chipBox: {
    backgroundColor: "#b0f2b6",
    fontWeight: 500,
    fontSize: 11,
    height: 18,
    marginTop: theme.spacing(-1),
    textOverflow: "ellipsis",
    maxWidth: theme.spacing(40),
    "& .MuiChip-labelSmall": {
      paddingLeft: 4,
      paddingRight: 4,
    },
  },
  message: {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    textAlign: "start",
  },
  date: {
    color: grey[700],
  },
  avatar: {
    border: `1.5px solid ${grey[600]}`,
  },
  onlineMarker: {
    "&:after": {
      content: "''",
      position: "absolute",
      top: 30,
      right: 1,
      width: 10,
      height: 10,
      backgroundColor: green[600],
      borderRadius: "50%",
      border: "2px solid white",
    },
  },
  badge: {
    fontSize: 10,
    backgroundColor: red[500],
    padding: "1px 7px 0",
    borderRadius: "50%",
    color: "white",
    marginLeft: 5,
  },
}));

/**
 * @param {ConversationItem} data
 * @returns {*}
 * @constructor
 */
const ChatListItem = ({ data }) => {
  const classes = useStyles();
  const { selectedEmployee, setSelectedEmployee } = useChat();
  const { formatSmartDate } = useDateUtils();

  let avatar = photoPlaceholder;

  if (data.photo && data.photo.url) {
    avatar = data.photo.url;
  }

  return (
    <ButtonBase
      className={clsx(classes.rootButton, { [classes.buttonActive]: data.userId === selectedEmployee })}
      onClick={() => setSelectedEmployee(data.userId)}
    >
      <Box display="flex" padding="10px" alignItems="stretch" width="100%" cursor="pointer">
        <Avatar className={classes.avatar} src={avatar} />
        {data.online && <Box className={classes.onlineMarker} width="0" position="relative" />}
        <Box
          minWidth="0" // чтобы бокс не растягивался шире, чем есть доступное пространство
          marginLeft="10px"
          flex="1"
        >
          {data?.userJobTitle && (
            <Box width="100%" textAlign="start">
              <Chip classes={{ root: classes.chipBox }} size="small" label={data.userJobTitle} />
            </Box>
          )}
          <Box display="flex" justifyContent="space-between">
            <Typography className={classes.userName} variant="body2">
              <b>{data.userName}</b>
            </Typography>
            <Typography className={classes.date} variant="body2">
              {formatSmartDate(data.date)}
            </Typography>
          </Box>
          <Box display="flex" justifyContent="space-between">
            <Typography className={classes.message} variant="body2">
              {data.lastMessage}
            </Typography>
            {data.unreadCount > 0 && <Typography className={classes.badge}>{data.unreadCount}</Typography>}
          </Box>
        </Box>
      </Box>
    </ButtonBase>
  );
};

ChatListItem.propTypes = {
  data: PropTypes.object.isRequired,
};

export default ChatListItem;
